export const PATIENT_SEX = {
  male: 'male',
  female: 'female',
  unknown: 'unknown',
} as const;

export type PatientSex = (typeof PATIENT_SEX)[keyof typeof PATIENT_SEX];

export const PATIENT_SEX_OPTIONS: PatientSex[] = [
  PATIENT_SEX.male,
  PATIENT_SEX.female,
  PATIENT_SEX.unknown,
];

export const PATIENT_CASE_STATUS = {
  active: 'active',
  paused: 'paused',
  completed: 'completed',
  archived: 'archived',
} as const;

export type PatientCaseStatus = (typeof PATIENT_CASE_STATUS)[keyof typeof PATIENT_CASE_STATUS];

export const PATIENT_CASE_STATUS_OPTIONS: PatientCaseStatus[] = [
  PATIENT_CASE_STATUS.active,
  PATIENT_CASE_STATUS.paused,
  PATIENT_CASE_STATUS.completed,
];
